module.exports = __webpack_public_path__ + "static/media/warning-green.e23880d8.svg";